<template>
  <v-card flat tile class="mb-4">
    <v-toolbar flat>
      <v-toolbar-title>Voice Naps
          <v-progress-circular v-show="loader.naps"
          :size="24"
          color="primary"
          indeterminate
        ></v-progress-circular>

      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/nap/settings">
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="text-xs-center">
            <div class="vocal-card-value headline">{{vocalNapsValue}}
                
            </div>
            <div class="vocal-card-label">Vocal Naps Taken</div>
            <div class="vocal-card-label">Extra Activity Pts Earned: {{ napTotalPoints }}</div>
          </div>
        </v-flex>
        <v-flex xs12>
          <div class="text-xs-center">
            <v-btn round color="primary" dark v-on:click.native="addANap()">Add Voice Nap</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
  import CreateActivityMutation from '../mutations/CreateActivityMutation';
  import { ListActivitiesForCurrentUser, GetActivityByUserQuery } from '@/components/queries'

  import AppConst from '../AppConst';

  export default {
    data() {
      return {
        activities: [],
        vocalNapsValue: 0,
        napValue: 1,
        allotment: 0, // no voice feeling selected. 
        // napTotalPoints: 0,
        // GetActivityByUserQuery: GetActivityByUserQuery,
        // CreateActivityMutation: CreateActivityMutation,
        loader: {
          naps: false
        }
      }
    },
    computed: {
      napTotalPoints() {
        const feel = AppConst.voiceFeelDefaults.find(feel => feel.maxValue === parseInt(this.allotment, 10));
        if (feel) {
          return this.vocalNapsValue * feel.napValue;
        } else {
          return 0;
        }
      }
    },
    methods: {
      async addANap() {
        this.loader.naps = true
        try {
          await this.addNapsDB()
          await this.refresh();
        } catch (err) {
          console.error(err);
          this.loader.naps = false;
        } finally {
          console.log('finally');
          this.loader.naps = false;
        }
        // localStorage.napsTakenValue = data;
      },
      // napValueFromAllotment(allotment) {
      //   this.napValue = AppConst.voiceFeelDefaults.find(feel => feel.maxValue === parseInt(allotment, 10)).napValue
      //   this.napTotalPoints = this.vocalNapsValue * this.napValue
      // },
      //@TODO: what is `value1`?
      async addNapsDB(napCount = 1) {
        //gather inputs
        const id = `${localStorage.subID}--${new Date().getTime()}`
        const username = localStorage.subID
        var input = {
          id,
          username,
          actDate: localStorage.currentDate,
          activityType: 'NapTaken',
          timestamp: (new Date().getTime()),
          value: napCount,
        }

        //add to dynamodb
        const result = await this.$apollo.mutate({
          variables: {
            input
          },
          mutation: CreateActivityMutation
        })
        this.$root.$emit('napChange')
      },


      async fetchActivities() {
        try {

          const params = {
            variables: {
              actDate: localStorage.currentDate,
            },
            query: ListActivitiesForCurrentUser
          }
          const response = await this.$apollo.query(params);
          const items = response.data.listActivitiesForCurrentUser.items;

          const naps = items.filter(it => it.activityType === "NapTaken")
          const vocalNapsValue = naps.reduce((t, { value }) => t + value, 0);
          this.vocalNapsValue = vocalNapsValue;

          const voiceFeeling = items.filter(it => it.activityType === 'VoiceFeeling').pop();
          const allotment = voiceFeeling ? voiceFeeling.value : 0;
          this.allotment = allotment;

          // this.vocalNapsValue = tempTotalAct;
          // this.napTotalPoints = this.vocalNapsValue * this.napValue
          // localStorage.napsTakenValue = tempTotalAct;
        } catch (err) {
          console.error(err);
          throw err;
        }
      },
      async refresh() {
        await this.fetchActivities();
      }
    },
    async mounted() {
      await this.refresh();

      // getNapsDB(this, function (data) {
      //   that.vocalNapsValue = data;
      //   localStorage.napsTakenValue = data;
      // });

      this.$root.$on('DateChange', this.refresh);

      // this.$root.$on('DateChange', data => {
      //   debugger;
      //   localStorage.currentDate = data;
      //   getNapsDB(this, function (data) {
      //     that.vocalNapsValue = data;
      //     localStorage.napsTakenValue = data;
      //   });
      // });
      // this.$root.$on('voiceFeelChange', this.napValueFromAllotment);
      this.$root.$on('voiceFeelChange', this.refresh);
    },
    updated() {
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/VocalNapsHome.vue